import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

// URL prefixes that should receive the Bearer token. Anything else (assets,
// translations, third-party) is passed through unchanged.
const PROTECTED_PREFIXES = ['/api', '/services', '/management'];

const isProtected = (url: string): boolean =>
  PROTECTED_PREFIXES.some((p) => url.startsWith(p)) ||
  // Absolute URLs back to the same origin pointed at the gateway
  PROTECTED_PREFIXES.some((p) => url.includes(p + '/'));

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  if (!isProtected(req.url)) {
    return next(req);
  }

  const token = authService.getAccessToken();
  const cloned = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(cloned).pipe(
    tap({
      error: (err: HttpErrorResponse) => {
        if (err.status === 401) {
          authService.logout();
        }
      },
    }),
  );
};
